import { render } from "./MainHeader.vue?vue&type=template&id=1922399a&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=1922399a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1922399a"]])

export default __exports__